import { Injectable, OnDestroy } from '@angular/core';
import { environment } from '@home/src/app/environments/environment';
import * as signalR from '@microsoft/signalr';
import { BehaviorSubject } from 'rxjs';
import { ApiUtils } from '../Utils/apiUtils';
import { get } from '@core/interceptors/fetch-client';

@Injectable({
  providedIn: 'root',
})
export class SignalrService implements OnDestroy {
  private hubConnection!: signalR.HubConnection;
  private connectionState = new BehaviorSubject<'disconnected' | 'connected'>(
    'disconnected',
  );
  connectionState$ = this.connectionState.asObservable();

  constructor() {}

  async getSignalRConnection(): Promise<any> {
    let response = null;
    try {
      await ApiUtils.handleApiResponse1(
        get<any>(environment.GetSignalRToken),
        (data: any, statusCode: number) => {
          response = { data, statusCode };
          if (statusCode === 200) {
            this.startConnection(data.url, data.accessToken);
          }
        },
        'Failed to fetch KPI Drop Down Data',
      );
    } catch (error: any) {
      response = {
        data: error,
        statusCode: error.statusCode || error.status || 500,
      };
    }
    return response;
  }

  startConnection(hubUrl: string, accessToken?: string) {
    if (this.hubConnection) return;

    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl, {
        accessTokenFactory: () => accessToken ?? '',
        transport: signalR.HttpTransportType.WebSockets,
      })
      .withAutomaticReconnect()
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.hubConnection
      .start()
      .then(() => this.connectionState.next('connected'))
      .catch(() => {
        this.connectionState.next('disconnected');
      });

    this.hubConnection.onclose(() => this.connectionState.next('disconnected'));
  }

  on<T>(eventName: string, callback: (data: T) => void) {
    if (!this.hubConnection) return;
    this.hubConnection.on(eventName, (data: T) => {
      callback(data);
    });
  }

  stopConnection() {
    if (this.hubConnection) {
      this.hubConnection.stop();
      this.connectionState.next('disconnected');
    }
  }

  ngOnDestroy() {
    this.stopConnection();
  }
}
